import React from 'react';

import Image from 'next/image';
import Link from 'next/link';

import { Post } from '@/types/wordpress';

interface RelatedBlogPostsProps {
  posts: Post[];
  currentPostId: number;
}

const RelatedBlogPosts: React.FC<RelatedBlogPostsProps> = ({ posts, currentPostId }) => {
  const relatedPosts = posts.filter(post => post.id !== currentPostId).slice(0, 3);

  return (
    <div className="mt-12 mb-8">
      <h2 className="text-2xl font-bold mb-6 text-primary">Recent Articles</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {relatedPosts.map(post => (
          <Link href={`/blog/${post.slug}`} key={post.id} className="group">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105">
              <div className="relative h-48">
                <Image
                  src={
                    post.featuredImage && typeof post.featuredImage === 'object'
                      ? post.featuredImage.sourceUrl
                      : '/images/placeholder-blog-image.jpg'
                  }
                  alt={post.title}
                  fill
                  className="object-cover"
                />
              </div>
              <div className="p-4">
                <h3 className="text-lg font-semibold mb-2 group-hover:text-primary transition-colors duration-300">
                  {post.title}
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {new Date(post.date).toLocaleDateString()}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedBlogPosts;
